var _g, _path, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTitle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 32,
    viewBox: "0 0 308 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_717_3833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0315 25.6H7.38795L3.694 32H11.8894L19.2774 19.2L15.5834 12.8H23.0315L26.7254 19.2L23.0315 25.6ZM3.694 6.4H19.3375L23.0315 0H14.836L7.44809 12.8L11.1592 19.1914H3.71117L-0.00854492 12.8L3.694 6.4Z",
    fill: "#191970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1145 25.5228C46.1916 25.5228 48.5969 22.9456 48.5969 20.0162C48.5969 13.2296 37.6267 15.7896 37.6267 11.8551C37.6267 10.4462 38.7865 9.33805 41.6471 9.33805C43.4456 9.36852 45.2048 9.86903 46.7499 10.7899L47.8324 8.11819C45.9701 7.013 43.8382 6.44508 41.6729 6.47738C36.5959 6.47738 34.2163 9.05456 34.2163 12.0097C34.2163 18.8822 45.2122 16.305 45.2122 20.2567C45.2122 21.6312 44.001 22.6621 41.1145 22.6621C38.9123 22.6596 36.7699 21.9455 35.0066 20.6261L33.8125 23.2978C35.3502 24.6207 38.2367 25.5228 41.1145 25.5228Z",
    fill: "#414A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0481 6.74365V19.2859L54.8424 6.74365H52.0161V25.2564H55.4266V12.7227L65.6322 25.2564H68.4585V6.74365H65.0481Z",
    fill: "#414A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3497 18.2722L80.7859 10.1799L84.2823 18.2722H77.3497ZM87.2976 25.2564H90.8885L82.5298 6.74365H79.1452L70.8123 25.2564H74.3602L76.1814 20.9611H85.4421L87.2976 25.2564Z",
    fill: "#414A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.699 17.0094H96.6787V9.65587H100.699C103.714 9.65587 105.278 11.0046 105.278 13.3326C105.278 15.6607 103.714 17.0094 100.699 17.0094ZM100.862 6.74365H93.2424V25.2564H96.6787V19.913H100.862C105.725 19.913 108.74 17.4046 108.74 13.3326C108.74 9.2607 105.725 6.74365 100.862 6.74365Z",
    fill: "#414A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.574 25.2564H118.524V8.436H125.036V6.74365H110.063V8.436H116.574V25.2564Z",
    fill: "#414A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.237 18.7275L133.678 8.77962L138.128 18.7275H129.237ZM141.058 25.2564H143.128L134.658 6.74365H132.734L124.263 25.2564H126.273L128.498 20.3082H138.807L141.058 25.2564Z",
    fill: "#414A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.969 22.2411C157.549 23.2239 155.85 23.7239 154.124 23.6671C153.095 23.7116 152.067 23.5457 151.104 23.1794C150.141 22.8132 149.263 22.2544 148.523 21.5371C147.783 20.8199 147.197 19.9593 146.802 19.008C146.406 18.0567 146.208 17.0346 146.221 16.0043C146.221 11.5802 149.58 8.33292 154.15 8.33292C155.179 8.2949 156.205 8.46728 157.165 8.83952C158.125 9.21175 158.999 9.77601 159.734 10.4977L160.945 9.2607C160.05 8.3595 158.976 7.65607 157.792 7.19588C156.608 6.73568 155.341 6.52894 154.073 6.58902C148.411 6.58902 144.288 10.5751 144.288 16.0387C144.288 21.5023 148.411 25.4884 154.047 25.4884C156.522 25.5518 158.936 24.7155 160.842 23.1345V16.0043H158.969V22.2411Z",
    fill: "#414A5A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.318 22.3639C189.61 22.071 189.61 21.5961 189.318 21.3032L184.014 15.9999L189.318 10.6966C189.61 10.4037 189.61 9.92883 189.318 9.63593C189.025 9.34304 188.55 9.34304 188.257 9.63593L182.954 14.9392L177.65 9.63593C177.357 9.34304 176.883 9.34304 176.59 9.63593C176.297 9.92883 176.297 10.4037 176.59 10.6966L181.893 15.9999L176.59 21.3032C176.297 21.5961 176.297 22.071 176.59 22.3639C176.883 22.6567 177.357 22.6567 177.65 22.3639L182.954 17.0606L188.257 22.3639C188.55 22.6567 189.025 22.6567 189.318 22.3639Z",
    fill: "#A0ACA9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_717_3833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.076 0L210.264 9.48839C209.205 9.9215 208.169 10.5412 207.732 12.2436L207.496 13.383L207.905 16.8379L228.921 8.14576C230.204 7.52608 230.92 6.74649 231.287 5.56044L233.076 0Z",
    fill: "url(#paint0_linear_717_3833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.902 20.4193L251.329 25.6032H245.522L251.166 6.86965C251.869 4.55752 252.629 2.91504 256.014 2.91504H268.191C268.097 3.2482 265.305 12.5167 264.209 16.1615C263.21 19.2032 261.941 20.4193 257.803 20.4193H252.902ZM258.719 15.142L261.124 7.14617H258.419C257.086 7.14617 256.863 7.29942 256.467 8.59208L254.261 15.9716H257.679C257.969 15.9716 258.486 15.9283 258.719 15.142Z",
    fill: "#EF3C2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.713 11.9306H275.56L276.416 9.0654C276.896 7.50288 277.233 7.06644 278.905 7.06644H286.441L287.687 2.90527H277.659C273.938 2.90527 271.995 4.43114 270.689 8.75223L267.324 19.9897C266.142 23.951 267.371 25.5235 271.296 25.5235H281.46L285.055 13.5964C285.555 11.9439 284.399 11.9306 283.713 11.9306ZM274.737 21.4989C273.764 21.4989 272.712 21.3856 273.121 20.0097L274.251 16.245H278.385L276.816 21.4989H274.737Z",
    fill: "#EF3C2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.982 2.91504H298.085C294.364 2.91504 292.421 4.44091 291.119 8.76199L286.078 25.5099H291.908L294.357 17.3742H299.021L296.573 25.5099H302.393L307.42 8.76199C308.72 4.44091 307.7 2.91504 303.982 2.91504ZM295.603 13.173L296.843 9.06517C297.329 7.50265 297.652 7.06621 299.328 7.06621H300.237C301.903 7.06621 302 7.49265 301.523 9.06517L300.271 13.173H295.603Z",
    fill: "#EF3C2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.287 25.4899H204.954L212.223 2.8584H218.56L211.287 25.4899Z",
    fill: "#444193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.845 11.8838L206.003 17.7307C205.443 19.4665 206.203 20.0362 206.796 20.396L226.822 30.724C227.948 31.2937 227.822 31.9767 227.822 31.9767L227.902 32.0033L229.358 27.3191C229.774 25.8332 229.554 25.2468 228.528 24.6538L208.682 14.4058C208.142 14.0727 207.466 13.5063 207.772 12.1803L207.845 11.8838Z",
    fill: "#EF3C2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.498 25.4801L243.83 21.0424H238.5C237.533 21.0424 236.681 20.8159 237.144 19.29L242.074 2.91187H236.227L231.023 20.1429C229.591 24.9071 231.69 25.4734 234.805 25.4734L242.498 25.4801Z",
    fill: "#EF3C2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_717_3833",
    x1: 209.195,
    y1: 4.45465,
    x2: 232,
    y2: 12.7501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#910508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#A70D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#C0151B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#CE2C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F26322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F7901E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFF8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FEBC11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F16122"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_717_3833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160.954,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_717_3833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103.003,
    height: 32,
    fill: "white",
    transform: "translate(204.954)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitle);
export default __webpack_public_path__ + "static/media/title.1524397287f6fbcaa528106c5a0418db.svg";
export { ForwardRef as ReactComponent };